<div class="bg-white dark:bg-gray-800 p-4 py-0">
    <p-button
        [text]="true"
        icon="pi pi-times"
        (click)="closeMenu()"
        severity="secondary"
        class="md:invisible visible top-2 right-2 absolute"
    />
    <ul class="mt-8 space-y-2">
        @for (item of menu(); track $index) {
            @if (item.separator) {
                <li class="py-2">
                    <div class="border-t border-gray-200 dark:border-gray-700"></div>
                </li>
            }
            <li>
                <a
                    (click)="goTo(item.routerLink)"
                    (keydown.enter)="goTo(item.routerLink)"
                    tabindex="0"
                    role="button"
                    class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-600 dark:text-gray-300 cursor-pointer"
                    [class]="item.routerLink === menuActive()
                    ? 'bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-700 hover:bg-amber-100 hover:text-amber-800 dark:hover:bg-amber-900/50 dark:hover:text-amber-100'
                    : 'border border-transparent hover:bg-gray-50 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white transition-colors'">
                    <i [class]="item.icon" class="shrink-0"></i>
                    <span>{{ item.label }}</span>
                </a>
            </li>
        }
    </ul>
</div>